

















import FavoriteItemService from '@/services/api/favorite-item'
import Vue from 'vue'

import { Component, Prop } from 'vue-property-decorator'

import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import { BrandRouteResolver } from '@/util/brandRouteResolver'

@Component
export default class Favorite extends Vue {

  /**
   * 商品詳細画面の初期表示状態のFKUのID。
   *
   * お気に入りの登録対象はこのFKUで固定であり、カルーセルのカラー切り替えには追従しない。
   * @see https://github.com/Everforth/growthpalette-front/issues/8759
   */
  @Prop({ required: true })
  fkuId: string

  /**
   * fkuIdと同じFKUの商品名
   */
  @Prop({ required: true })
  fkuName: string

  show: boolean = false
  like: boolean = false
  animation: boolean = false
  processing: boolean = false

  status: {
    liked: string;
    notLiked: string;
  } = {
    liked: 'c-favorite--register',
    notLiked: 'c-favorite--deregister',
  }

  classes: {
    root: string;
  } = {
    root: 'c-favorite',
  }

  favoriteItemService = new FavoriteItemService()

  get brandEnglishName(): string {
    return BrandRouteResolver.resolveBrandFromPathElement(this.$route.params.brand_english_name)
  }

  async mounted() {
    /**
     * 「商品詳細画面の閲覧イベント」は本来、このお気に入りボタン用のコンポーネントで送信すべきものではない。
     * しかしMPAである商品詳細画面に対してajaxで付属させている各種コンポーネントのうち、商品詳細=FKUの粒度でちょうどよい情報を持ったコンポーネントが見当たらないため、
     * 便宜上、一時的にここで送信している。
     *
     * すくなくともGAで求められているEコマース向けのデータは、ユーザ依存ではないので、PHPテンプレートで送信してもよいのかもしれない。
     * しかし価格については、有効な会員価格をどこかから取得してこなければならない。（価格はいったんMUSTではない）
     * その場合、商品詳細用のajaxで付属させられるVueコンポーネントが、個別に商品情報を取得するのではなく、一括で必要なデータを取得してから各コンポーネントにデータを受け渡すようにし、
     * 一括で取得する箇所で、「商品詳細画面の閲覧イベント」用に必要なデータを取得する、ということが考えれる。
     */
    EventBusForThirdParty.getInstance().publish('item-detail-view', {
      fkuId: this.fkuId,
      fkuName: this.fkuName,
    })

    const exists = await this.favoriteItemService.exists(this.fkuId, this.brandEnglishName)
    this.like = exists.getOrElse(false)
    this.show = true
  }

  /**
   * ハートアイコンのON/OFFをするクラスに対応
   * TODO: Rename
   */
  get animate() {
    return {
      animate: this.animation,
    }
  }

  async toggleLike() {
    // 送信中の再操作は受け付けない。応答前に二度目を送ると、両方が同じ向きの更新になり画面とサーバーが食い違う
    if (this.processing) {
      return
    }

    // 目標状態はリクエスト開始時点で確定させる。応答後に現在値を反転させると連打時に逆転する
    const target = !this.like
    this.processing = true

    try {
      const response = target
        ? await this.favoriteItemService.add(this.fkuId, this.brandEnglishName)
        : await this.favoriteItemService.remove(this.fkuId, this.brandEnglishName)

      if (response.isLeft()) {
        const message = 'お気に入りの際にエラーが発生しました。お手数ですがお問い合わせ下さい。'
        this.$store.commit('error/set', { message })

        return
      }

      this.like = target
      this.animation = target

      if (target) {
        EventBusForThirdParty.getInstance().publish('add-to-favorite', {
          fkuId: this.fkuId,
          fkuName: this.fkuName,
        })
      }
    } finally {
      this.processing = false
    }
  }

  close() {
    /**
     * FIXME: Favoriteコンポーネントにダイアログを組み込むのではなく、商品詳細全体でコンポーネントダイアログを共有する
     *
     * ダイアログ自体はstoreを参照しているので他所からstoreのデータが更新されるだけでもエラーダイアログが表示されはする.
     * しかし、エラーダイアログがトップレベルに配置されることなくFavorite内部に埋め込まれる形となることで、
     * Favoriteという特定コンポーネントとの結合が、store経由によって疎結合気味ながらも暗黙的かつ暗号的な結合が派生している.
     *
     * 「実はFavoriteに依存している」という形式を取るよりは、明示的にページ全体へダイアログコンポーネントを挿入して
     * 「storeからイベントを打ち上げれば、トップレベルで共有されているダイアログにそれが伝播して表示される」という形式にしたい.
     * Favoriteへの暗黙的依存があると、仮にFavoriteコンポーネントが取り除かれる or リライトされた時に
     * エラーダイアログが正常に表示されない、という事態になりかねない
     * （かつ、「Favoriteを消すとダイアログが出ない」という結果は全く非自明かつ予測しにくい）.
     *
     * 特定コンポーネントに埋め込むのではなく、全体で共有される仕組みとしてダイアログを位置づけたい.
     * （このことは、Favoriteに限らず直接ダイアログを埋め込んでいるコンポーネントにも共通して言えることではある）
     */
    this.$store.commit('error/clear')
  }
}
